var map = {
	"./allerum-golf-club/slide.jpg": 71688,
	"./forsbacka-golf-club/slide.jpg": 47464,
	"./gumbalde-resort/slide.jpg": 62899,
	"./isaberg-golf-club/slide.jpg": 69157,
	"./karlshamn-golf-club/slide.jpg": 99643,
	"./laholms-golf-club/slide.jpg": 360,
	"./landeryd-golf-club/slide.jpg": 89437,
	"./linkoping-golf-club/slide.jpg": 17041,
	"./malaro-golf-club/slide.jpg": 38462,
	"./rya-golf-club/slide.jpg": 27726,
	"./sjobo-golf-club/slide.jpg": 84949,
	"./skerike-golf-club/slide.jpg": 58694,
	"./soderslatt-golf-club/slide.jpg": 66583,
	"./solvesborg-golf-club/slide.jpg": 75928,
	"./trummenas-golf-club/slide.jpg": 35710,
	"./upsala-golf-club/slide.jpg": 30782,
	"./varberg-golf-club/slide.jpg": 80679,
	"./vreta-kloster-golf-club/slide.jpg": 31361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62851;